<template>
  <div id="technologies" class="pt-5 position-relative">
    <div class="container">
      <h1 class="title">{{ $t('section.technologies') }}</h1>
      <hr class="w-25 bg-primary mt-1"/>

      <p class="text-center">{{ $t('technologies.description') }}</p>

      <div class="d-none d-md-flex justify-content-around align-items-center flex-wrap">
        <div v-for="technology in tehcnologies" :key="technology.name" class="tech-item">
          <a :href="technology.url" target="_blank" :title="$t('action.go_to_website')">
            <img :src="getImgUrl(technology.name)" :alt="technology.name" class="m-1" />
          </a>
        </div>
      </div>

      <div id="carouselTS" class="d-block d-md-none carousel slide mx-auto" data-ride="carousel">
        <div class="carousel-inner">
          <div v-for="(tech, index) in tehcnologies" :key="`tech-${index}`" :class="`carousel-item  ${index === 0 ? 'active' : ''}`">
            <a :href="tech.url" target="_blank" :title="$t('action.visit')">
              <div class="d-flex justify-content-center align-items-center mx-auto" style="width: 250px; height: 250px;">
                <img :src="getImgUrl(tech.name)" class="d-block" :alt="tech.name" style="max-height: 250px;" />
              </div>
            </a>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselTS" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon bg-dark-transparent" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselTS" role="button" data-slide="next">
          <span class="carousel-control-next-icon bg-dark-transparent" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>

    </div>
    <Divider/>
  </div>
</template>

<script>
import Divider from './Layout/Divider.vue'

export default {
  name: 'technologies',
  data: () => ({
    images: null,
    tehcnologies: [
      { name: 'ruby', url: 'https://www.ruby-lang.org' },
      { name: 'php', url: 'https://php.net' },
      { name: 'javascript', url: 'https://www.javascript.com/' },
      { name: 'html5', url: 'https://developer.mozilla.org/es/docs/HTML/HTML5' },
      { name: 'css', url: 'https://www.w3schools.com/css/' },
      { name: 'ror', url: 'https://rubyonrails.org' },
      { name: 'vuejs', url: 'https://vuejs.org' },
      { name: 'reactjs', url: 'https://reactjs.org/' },
      { name: 'webpack', url: 'https://webpack.js.org/' },
      { name: 'highcharts', url: 'https://www.highcharts.com/' },
      { name: 'datatablejs', url: 'https://datatables.net/' },
      { name: 'sass', url: 'https://sass-lang.com/' },
      { name: 'wordpress', url: 'https://wordpress.org' },
      { name: 'mongodb', url: 'https://www.mongodb.com/' },
      { name: 'mysql', url: 'https://www.mysql.com/' },
      { name: 'postgresql', url: 'https://www.postgresql.org/' },
      { name: 'bootstrap', url: 'https://getbootstrap.com/' },
      { name: 'material-design', url: 'https://material.io/develop/' },
      { name: 'git', url: 'https://git-scm.com/' },
      { name: 'gitlab', url: 'https://about.gitlab.com/' },
      { name: 'bitbucket', url: 'https://bitbucket.org' },
      { name: 'centos', url: 'https://www.centos.org/' },
      { name: 'ubuntu', url: 'https://www.ubuntu.com' },
      { name: 'digitalocean', url: 'https://www.digitalocean.com/' }
    ]
  }),
  components: { Divider },
  created () {
    this.images = require.context('../assets/images/technologies/', false, /\.png$/)
  },
  methods: {
    getImgUrl (technology) {
      return this.images(`./${technology}.png`)
    }
  }
}
</script>

<style lang="scss" scoped>
.tech-item:hover {
  animation-name: getting-closer;
  animation-duration: .8s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
}

@keyframes getting-closer {
  0% {
    transform: scaleY(0.8);
  }

  25% {
    transform: scaleY(1.2) skew(10deg, 5deg);
  }

  50% {
    transform: scaleY(0.9) skew(-10deg, -5deg);
  }

  75% {
    transform: scaleY(1.1) skew(10deg, 5deg);
  }

  100% {
    transform: scaleY(1);
  }
}
</style>
